/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

const findLabel = function(modal) {
  const label = modal.attr('data-analytics-label');
  if (label) {
    return $.trim(label);
  } else {
    return $.trim(modal.find(".headline, h1, h2, h3, h4, h5, h6").first().text());
  }
};

root.initCloseModal = () => $('.close-modal').click(function() {
  const obj = $(this);
  return obj.parents('.reveal').foundation('close');
});

/*
$(function() {
  $(document).on("open.zf.reveal", "[data-reveal]", function() {
    const modal = $(this);
    initAutofocus(modal);
    modal.find('.close-modal').click(() => modal.foundation('close'));
    (typeof analytics !== 'undefined' && analytics !== null) && analytics.track("Open Modal", {label: findLabel(modal)});
  });

  return $(document).on("closed.zf.reveal", "[data-reveal]", function() {
    const modal = $(this);
    (typeof analytics !== 'undefined' && analytics !== null) && analytics.track("Close Modal", {label: findLabel(modal)});
  });
});

*/

function initModalsOnLoad() {
  if ($('.reveal-overlay').length) {
    $(document).on("open.zf.reveal", "[data-reveal]", function() {
      const modal = $(this);
      initAutofocus(modal);
      modal.find('.close-modal').click(() => modal.foundation('close'));
      (typeof analytics !== 'undefined' && analytics !== null) && analytics.track("Open Modal", {label: findLabel(modal)});
    });

    return $(document).on("closed.zf.reveal", "[data-reveal]", function() {
      const modal = $(this);
      (typeof analytics !== 'undefined' && analytics !== null) && analytics.track("Close Modal", {label: findLabel(modal)});
    });
  }
}

$(initModalsOnLoad);
document.addEventListener('turbo:load', initModalsOnLoad);
